export default (data: number): string => {
    const regex = /\B(?=(\d{3})+(?!\d))/g;
    if (data === undefined) return '0';
    return data.toString().replace(regex, ',');
  };